import { useQuery } from '@tanstack/react-query';
import { authQueries } from '../queries';

export function useMe() {
  return useQuery(authQueries.me());
}
